// extracted by mini-css-extract-plugin
export default {"mapContainer":"costTab_mapContainer__1cFLv","mapModalClass":"costTab_mapModalClass__QSEbQ"};